export default __webpack_public_path__ + "images/WW.71286d4.png";